$mol_icon_format_vertical_align_bottom $mol_icon path \M16,13H13V3H11V13H8L12,17L16,13M4,19V21H20V19H4Z
